import React, { useRef, useState, useEffect, useContext } from 'react';
import placeholder from '../assets/placeholder.jpg';
import '../pages/Profile.css';
import { InputContext } from '../components/InputContext';

const baseURL = process.env.REACT_APP_API_URL;

const ProfileImageUpload = () => {
  const fileInputRef = useRef(null);

  const { username } = useContext(InputContext);  

  const [imageSrc, setImageSrc] = useState(placeholder);

  useEffect(() => {
    if (!username) return;

    fetch(`${baseURL}/user/${username}`)
      .then(res => res.json())
      .then(data => {
        if (data.profileImage) {
          setImageSrc(`${baseURL}/uploads/profiles/${data.profileImage}`);
        }
      });
  }, [username]);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file || !file.type.startsWith('image/')) return;

    const formData = new FormData();
    formData.append('profileImage', file);
    console.log('Current username from context:', username);
    formData.append('username', username);

    try {
      const res = await fetch(`${baseURL}/acc/profile/upload-image`, {
        method: 'POST',
        body: formData
      });

      if (!res.ok) {
        const text = await res.text(); 
        console.error('Server error:', res.status, text);
        return;
      }

      const data = await res.json();
      setImageSrc(`${baseURL}/uploads/profiles/${data.imageFilename}`);
    } catch (err) {
      console.error('Upload failed', err);
    }
  };

  return (
    <div className="image-upload">
      <img
        src={imageSrc}
        alt="Profile"
        className="profile-image click"
        onClick={handleImageClick}
      />
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};

export default ProfileImageUpload;